import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {useMediaQuery, Divider, Typography} from '@material-ui/core';
import {Topbar, Footer, Sidebar} from './components';
import {showHowToStart, showSupport, showHelp, showUltimateGuide, showCookieWidget} from "common/index";
import ContactDialog from "../../views/ContactDialog";
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
    },
}));

const Main = props => {
    const {children} = props;

    const classes = useStyles();

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const pages = {
        features: {
            title: 'Features', href: '/features'
        },
        plans: {
            title: 'Plans', href: '/pricing'
        },
        landings: {
            title: "About Us",
            id: 'landing-pages',
            children: {
                company: {
                    groupTitle: 'Company',
                    pages: [
                        {
                            title: 'Our People',
                            href: '/about#leadership',
                        },
                        {
                            title: 'Privacy Policy',
                            href: 'https://www.chargebee.com/privacy',
                        },
                        {
                            title: 'Service Terms',
                            href: '/tos',
                        },
                        {
                            title: 'Security',
                            href: '/security',
                        },
                    ],
                }
            },
        },
        resources: {
            title: 'Resources',
            id: 'supported-pages',
            children: {
                blog: {
                    groupTitle: 'Blog',
                    pages: [
                        {
                            title: 'Recent Posts',
                            href: '/blog-reach-view',
                        },
                        {
                            title: 'Ultimate Guide',
                            onClick: showUltimateGuide
                        },
                        {
                            title: 'Help Center',
                            onClick: showHelp,
                        },
                        {
                            title: 'FAQ',
                            href: '/pricing#faq',
                        }
                    ],
                },
                helpCenter: {
                    groupTitle: 'Help center',
                    pages: [
                        {
                            title: 'Get Support',
                            onClick: showSupport,
                        },
                        {
                            title: 'Quick Start',
                            onClick: showHowToStart
                        },
                        {
                            title: 'Do not sell or share my personal information',
                            onClick: showCookieWidget
                        }
                    ]
                }
            },
        }
    };

    const [openSidebar, setOpenSidebar] = useState(false);
    const [showContact, setShowContact] = useState(false)

    const handleSidebarOpen = () => {
        setOpenSidebar(true);
    };

    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };

    const open = isMd ? false : openSidebar;

    return (
       <div
          className={clsx({
              [classes.root]: true,
          })}
       >
           <Alert severity="info">🎉🎉&nbsp;&nbsp;<b>REVLOCK</b> is now <a style={{textDecoration: 'underline'}} href='https://www.chargebee.com/saas-accounting-and-taxes/revenue-recognition-deferred-revenue/'>Chargebee RevRec</a> 🎉🎉 </Alert>
           <Topbar onSidebarOpen={handleSidebarOpen}
                   showContact={() => setShowContact(true)}
                   pages={pages}/>
           <Sidebar
              onClose={handleSidebarClose}
              open={open}
              variant="temporary"
              pages={pages}
           />
           <main>
               <Divider/>
               {children}
           </main>
           <Footer pages={pages}/>
           <ContactDialog open={showContact}
                          onClose={() => setShowContact(false)}/>
       </div>

    );
};

Main.propTypes = {
    children: PropTypes.node,
};

export default Main;
